export default __webpack_public_path__ + "boundaries-sample-480-7ce971185b7d814e6b15160ccd0740a7.png";